import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { MapPin, Clock } from 'lucide-react';
import { EscortProfile } from '@/types';

interface ContactInformationSectionProps {
  profile: EscortProfile;
  t: (key: string) => string;
}

export const ContactInformationSection: React.FC<ContactInformationSectionProps> = ({ profile, t }) => {
  // Return null if no contact info or if it shouldn't be shown (handled by parent)
  if (!profile.contactInfo) {
    return null; 
  }

  return (
    <Card className="mb-6 border-pink-100">
      <CardContent className="p-0">
        <div className="bg-pink-50 py-3 px-6 border-b border-pink-100">
          <h3 className="text-lg font-medium text-pink-700 flex items-center">
            <MapPin size={18} className="mr-2 text-pink-500" />
            {t('profile.contact_availability')}
          </h3>
        </div>
        <div className="p-6">
          <div className="space-y-4">
            <div className="flex items-center">
              <MapPin size={18} className="mr-2 text-pink-500" />
              <span className="text-muted-foreground w-32">{t('city')}:</span>
              <span className="font-medium">{profile.location.city}, {profile.location.country}</span>
            </div>

            <div className="mt-4">
              <h4 className="text-sm font-medium text-pink-700 mb-2 flex items-center">
                <Clock size={16} className="mr-2 text-pink-500" />
                {t('profile.working_hours')}
              </h4>
              <div className="grid grid-cols-2 gap-2">
                <div className="flex justify-between">
                  <span className="text-muted-foreground">{t('day_monday')}</span>
                  <span>10:00 - 22:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">{t('day_tuesday')}</span>
                  <span>10:00 - 22:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">{t('day_wednesday')}</span>
                  <span>10:00 - 22:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">{t('day_thursday')}</span>
                  <span>10:00 - 22:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">{t('day_friday')}</span>
                  <span>10:00 - 22:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">{t('day_saturday')}</span>
                  <span>10:00 - 22:00</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-muted-foreground">{t('day_sunday')}</span>
                  <span>10:00 - 22:00</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}; 